export default defineNuxtPlugin(async () => {
  const sentryService = useSentryService()

  window.ms_initSentry = (event) => sentryService.initSentry(event)

  document.addEventListener('scroll', window.ms_initSentry)
  document.addEventListener('mousemove', window.ms_initSentry)
  document.addEventListener('touchstart', window.ms_initSentry)
})
